module.exports = __webpack_public_path__ + "img/product-placeholder-6.b6d83ac.png";